import React, { useState } from 'react';
import { ICON_NEW } from '../extras/icons';
import MainContent from '../layout/MainContent';
import OfijuList from './ofijus/OfijuList';
import OfijuForm from './ofijus/OfijuForm';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { addOfijusAction } from '../../actions/ofijusActions';
import AuthoritiesService from '../../services/AuthoritiesService';
import { OFIJUS_CREAR } from '../../data/objects';
//Función principal
const Ofijus = () => {
    //Inicializo el state local
    const [show, setShow] = useState(false);
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Manejo el insert
    const handleCreate = () => {
        //Llamo al dispatch
        dispatch( addOfijusAction(handleOpen) );
    }
    //Nodos
    const nodes = [];
    //Actions
    const actions = [{
        title: 'NUEVO',
        css: 'success',
        icon: <ICON_NEW className="fa-sm text-white-50" />,
        handle: handleCreate,
        granted: authorities && AuthoritiesService.hasPermission(authorities, OFIJUS_CREAR)
    }];
    //Manejo la apertura de la ventana
    const handleOpen = () => {
        setShow(true);
    }
    //Manejo el cierre de la ventana
    const handleClose = () => {
        setShow(false);
    }
    //Renderizo
    return (
        <React.Fragment>
            <MainContent 
                title='Ofijus' 
                subtitle='Administración' 
                nodes={nodes}
                actions={actions}
                component={OfijuList}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />

            <OfijuForm
                show={show}
                handleClose={handleClose}
            />
        </React.Fragment>
    );
};

export default Ofijus;